module.exports = "### What is React?\n- A library for building user interfaces\n- NOT a framework\n\n### => Declarative\n- No manual DOM manipulation\n\n- Declare state of app, React handles rendering and updating\n\n### => Component-Based\n- encapsulated, manage own state\n\n- No need to track state in the DOM\n\n- composed to make more complex UIs\n\n\n### => Used Anywhere\n- Add to existing projects and live alongside legacy code\n\n- Render on the server with Node\n\n- Develop mobile apps with React Native\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/02_what_is_react/notes_1.md
// module id = 1448
// module chunks = 0